import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

import { usePuppyMode } from '../../contexts/PuppyModeContext';

/**
 * For pages that cannot be filtered by dogfooding. Shows only while
 * dogfooding mode is on, so nobody reads the list as dogfooding-only.
 */
export const NoDogfoodingWarning: React.FC<{ subject: string }> = ({
  subject,
}) => {
  const { filterMode } = usePuppyMode();

  if (filterMode !== 'puppy') {
    return null;
  }

  return (
    <div
      role="alert"
      className="mx-6 mt-6 flex items-center gap-2 rounded-medium border border-warning-200 bg-warning-50 p-3 text-sm text-warning-700"
    >
      <FiAlertTriangle className="h-4 w-4 shrink-0" />
      <p>
        There is no dogfooding for {subject}. This page shows everything, not
        only dogfooding accounts.
      </p>
    </div>
  );
};
